module.exports = __webpack_public_path__ + "static/media/Compass_base.4a1f7562.svg";